import { instance } from "@/api/index";

export const getPlanTys = () => instance.get("/back/planTy");
export const getPlanTy = planTyNo => instance.get(`/back/planTy/${planTyNo}`);
export const setPlanTy = payload => instance.post("/back/planTy", payload);
export const modiPlanTy = (planTyNo, payload) =>
  instance.put(`/back/planTy/${planTyNo}`, payload);
export const delPlanTy = planTyNo =>
  instance.delete(`/back/planTy/${planTyNo}`);
